import React, {Component} from "react";
import {Toaster} from "react-hot-toast";
import classNames from "classnames";

class FullWidthLayout extends Component {
    constructor(props) {
        super(props);
    }



    render() {
        const {
            children,
            showMessages = true,
            pageClass
        } = this.props;
        return (
            <div className={classNames("page", pageClass,)}>

                {showMessages && this.props.messages && this.props.messages.length > 0 && (
                    <div className="container-xl">
                        <div className="row mb-2">
                            <div className="col-12">
                                {this.props.messages.map((message, index) => (
                                    <div key={index}
                                         className={`alert alert-${message.level} alert-dismissible`}
                                         role="alert">
                                        <div className="d-flex">
                                            <div>
                                                {message.level === 'success' ? (
                                                    <i className="icon alert-icon ti ti-check"></i>
                                                ) : (
                                                    <i className="icon alert-icon ti ti-alert-triangle"></i>
                                                )}
                                            </div>
                                            <div>
                                                {message.message}
                                            </div>
                                        </div>
                                        <button className="btn-close" data-bs-dismiss="alert"
                                                aria-label="close"></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {children}
                <div><Toaster position="bottom-center"/></div>
            </div>
        );
    }
}

export default FullWidthLayout;
